export default __webpack_public_path__ + "static/media/pheasant.2dc72e74.png";